import React, { useEffect, useState } from 'react';
import { Search, Menu, X } from 'lucide-react';

const LOGO_URL =
  'https://customer-assets-jt897jd0.emergentagent.net/job_jh-intl-recruitment/artifacts/g0jgfmtg_logo.png';

const NAV = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Industries', href: '#industries' },
  { label: 'Why Ghana', href: '#why-ghana' },
  { label: 'Licences', href: '#licences' },
  { label: 'Contact', href: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'jh-nav-scrolled' : 'bg-transparent'
      }`}
      style={{ backgroundColor: scrolled ? undefined : 'rgba(14,20,33,0.55)' }}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-[88px] flex items-center justify-between">
        {/* Logo */}
        <a href="#home" className="flex items-center gap-3">
          <img
            src={LOGO_URL}
            alt="John Herbert Limited"
            className="h-9 md:h-10 w-auto object-contain select-none"
            draggable={false}
          />
        </a>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.label}
              href={n.href}
              className="text-white/85 hover:text-white text-[15px] font-medium transition-colors relative group"
            >
              {n.label}
              <span className="absolute -bottom-1 left-0 h-[2px] w-0 bg-[#E11D2E] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <button
            aria-label="Search"
            className="hidden md:inline-flex items-center justify-center w-10 h-10 rounded-full text-white/85 hover:text-white hover:bg-white/10 transition-colors"
          >
            <Search size={18} />
          </button>
          <button
            aria-label="Toggle menu"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-md text-white hover:bg-white/10"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden jh-dark border-t border-white/10">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <a
                key={n.label}
                href={n.href}
                onClick={() => setOpen(false)}
                className="text-white/90 hover:text-white text-base font-medium"
              >
                {n.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
